import { createFileRoute } from "@tanstack/react-router";

import { ENGAGEMENT_FAQS } from "@/components/marketing/bluesky-engagement-faqs";
import { BlueskyEngagementTool } from "@/components/marketing/bluesky-engagement-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole tool into the shared entry chunk. The FAQs live in
 * their own module for exactly this reason; see `bluesky-engagement-faqs.ts`.
 */
export const Route = createFileRoute("/(public)/tools/bluesky-engagement-rate")(
  {
    head: () => toolPageHead("blueskyEngagementRate", ENGAGEMENT_FAQS),
    component: BlueskyEngagementTool,
  },
);
